import { render } from "./VirtualReality.vue?vue&type=template&id=60109858"
import script from "./VirtualReality.vue?vue&type=script&lang=js"
export * from "./VirtualReality.vue?vue&type=script&lang=js"

import exportComponent from "E:\\2023\\Documents\\GitHub\\POS-APP-FrontEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__